export default "__VITE_PUBLIC_ASSET__da05687c__"